import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewObjectDetails: {
		id: 'servicedesk-insight-attribute-list.button-attribute-with-avatar.view-object-details',
		defaultMessage: 'View details',
		description: 'Tooltip label shown on the object attribute link',
	},
});
